import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const ListHeader = ({ onSortRate, sortRate }) => {
  const { config } = useSelector((state) => state.services);

  return (
    <div className="services-import__list-header">
      <div>Services</div>
      <div>
        <button
          className={classNames('rate-sort-btn', {
            active: sortRate === 'asc' || sortRate === 'desc',
          })}
          onClick={onSortRate}
        >
          <span className={classNames('fas', {
            'fa-sort-amount-down-alt': sortRate === 'all' || sortRate === 'asc',
            'fa-sort-amount-down': sortRate === 'desc',
          })}
          />
        </button>
        <span>
          Rate,
          {' '}
          {config.currency}
        </span>
      </div>
    </div>
  );
};

ListHeader.propTypes = {
  onSortRate: PropTypes.func,
  sortRate: PropTypes.string,
};

export default ListHeader;
